import { useEffect } from 'react';

import { useDefaultLocale } from 'applications/GSP/shared/hooks/localization';

import { useResources } from './hooks';
import { updateResources } from './utils';

export const useUpdateResources = async () => {
  const defaultLocale = useDefaultLocale();
  const resources = useResources();

  useEffect(() => {
    updateResources(defaultLocale, resources);
  }, [defaultLocale, resources]);
};
